import { useEffect, useState } from "react";
import axios from "axios";
import { money } from "@/components/creatives/CostWidget";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/creatives`;

export const ModelPicker = ({ value, onChange, ar, n }) => {
  const [models, setModels] = useState([]);
  useEffect(() => { axios.get(`${API}/models`).then((r) => setModels(r.data.items || [])).catch(() => {}); }, []);
  const toggle = (k) => {
    if (value.includes(k)) { if (value.length > 1) onChange(value.filter((x) => x !== k)); }
    else if (value.length < 3) onChange([...value, k]);
  };
  const est = models.filter((m) => value.includes(m.key)).reduce((s, m) => s + (m.cost_usd[ar] || 0) * n, 0);

  return (
    <div className="space-y-1.5" data-testid="model-picker">
      <div className="flex flex-wrap gap-1.5">
        {models.map((m) => {
          const on = value.includes(m.key);
          return (
            <button key={m.key} data-testid={`model-${m.key}`} onClick={() => toggle(m.key)} title={m.hint}
              className={`rounded-lg border px-2.5 py-1 text-left transition-colors ${on ? "border-amber-400 bg-amber-400/10" : "border-zinc-700 hover:border-zinc-500"}`}>
              <span className={`block text-xs font-medium ${on ? "text-amber-100" : "text-zinc-300"}`}>{m.label}</span>
              <span className="block text-[11px] text-zinc-400">{m.hint} · ${m.cost_usd[ar].toFixed(3).replace(/0$/, "")}</span>
            </button>
          );
        })}
      </div>
      <p className="text-[11px] text-zinc-400" data-testid="estimated-cost">
        {value.length > 1 ? `Compar ${value.length} modele · ` : ""}Cost estimat la generare: {money(est)}
      </p>
    </div>
  );
};
